import { MY_DAY_STEP_STATUS } from '../../../../common/utils/myDay/driverDaySteps';
import { getEntrySyncState, getQueuedStepEntries } from '../stepSyncState';

const isOpenStep = step => step.status !== MY_DAY_STEP_STATUS.DONE && step.status !== MY_DAY_STEP_STATUS.BLOCKED;

/**
 * "After this: …" line for the start of day dock: the next visible step after
 * `stepKey` that is still open, else starting the run (null once it started
 * or when `stepKey` is not a visible step).
 */
export const getStartOfDayAfterThis = (visibleSteps, stepKey, runStarted) => {
	const index = visibleSteps.findIndex(step => step.key === stepKey);
	if (index < 0) {
		return null;
	}
	const nextStep = visibleSteps.slice(index + 1).find(isOpenStep);
	if (nextStep) {
		return `After this: ${nextStep.label}`;
	}

	return runStarted ? null : 'After this: Start service run';
};

/**
 * Whether a done start of day step is only saved on this phone (queued
 * confirmation or checklist): STEP_SYNC_STATE.PENDING, FAILED (sync failed,
 * retried from the sync banner) or null when it reached the server.
 * With several queued entries the first one decides.
 */
export const getStartStepSyncState = (step, context) => {
	const [entry] = getQueuedStepEntries(step, context);
	return entry ? getEntrySyncState(entry) : null;
};
